import axios from "axios";
import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import { CheckBudgetYear } from "../../../Function/CheckBudgetYear";
import { GetCookieToken } from "../../../Cookie/GetCookie";

import { ConvertDate } from "../../../Function/ConvertDate";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import SubMenuLeave from "../../SubMenuLeaveOnline";
import NewThaiDatePicker from "../../../../components/Common/NewThaiDatePicker";
import { FetchAxiosDelte } from "../../../../api/axios";
import ConfirmModal from "../../../../components/Common/ConfirmModal";

const Menu5 = () => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  let budget_year = CheckBudgetYear();

  const [modalAdd, setModalAdd] = useState(false);
  const [modalState, setModalState] = useState("");
  const [selectBudgetYear, setSelectBudgetYear] = useState(budget_year);
  const [holiday, setHoliday] = useState([]);
  const [totalRows, setTotalRows] = useState();
  const [deletedID, setDeletedID] = useState(null);
  const [currentYears, setCurrentYears] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [data, setData] = useState({
    name_holiday: "",
    date_start_holiday: new Date(),
    date_end_holiday: new Date(),
  });
  const [holidayByID, setHolidayByID] = useState({
    holiday_main_id: "",
    name_holiday: "",
    date_start_holiday: "",
    date_end_holiday: "",
  });

  const toggleModalAdd = () => {
    if (modalAdd === true) {
      setHolidayByID();
      setModalAdd(!modalAdd);
    } else if (modalAdd === false) {
      setModalAdd(!modalAdd);
    }
  };

  const getHolidays = async (budgetYear) => {
    try {
      const res = await axios.get(
        baseURL + `/api/masterdata/holiday/${budgetYear}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setHoliday(res?.data?.result);
      setTotalRows(res?.data?.result?.length);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    // getHolidays(selectBudgetYear - 543);
    getHolidays(new Date().getFullYear());
  }, []);

  const handleSubmit = async () => {
    try {
      const res = await axios.post(
        baseURL + "/api/masterdata/holiday/save",
        {
          name_holiday: data?.name_holiday,
          date_start_holiday: ConvertDate(
            data?.date_start_holiday
          ).toOnlyDate(),
          date_end_holiday: ConvertDate(data?.date_end_holiday).toOnlyDate(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toggleModalAdd();
      getHolidays(currentYears ?? selectBudgetYear - 543);
    } catch (err) {
      console.error(err);
    }
  };

  const getHolidayByID = (id) => {
    let findData = holiday.find((item) => item.holiday_main_id === id);
    setHolidayByID((prev) => ({
      ...prev,
      holiday_main_id: findData?.holiday_main_id,
      name_holiday: findData?.name_holiday,
      date_start_holiday: new Date(findData?.date_start_holiday),
      date_end_holiday: new Date(findData?.date_end_holiday),
    }));
  };

  const handleEdit = async (id) => {
    try {
      const res = await axios.put(
        baseURL + `/api/masterdata/holiday/${id}`,
        {
          name_holiday: holidayByID?.name_holiday,
          date_start_holiday: ConvertDate(
            holidayByID?.date_start_holiday
          ).toOnlyDate(),
          date_end_holiday: ConvertDate(
            holidayByID?.date_end_holiday
          ).toOnlyDate(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toggleModalAdd();
      getHolidays(currentYears ?? selectBudgetYear - 543);
    } catch (err) {
      console.error(err);
    }
  };


  const AddHolidayToEvent = () => {
    setEvents([])
    if (holiday.length !== 0) {
      holiday?.map((item) => {
        let newEvent = {
          id: item?.holiday_main_id,
          title: item?.name_holiday,
          start: new Date(item?.date_start_holiday),
          end: new Date(item?.date_end_holiday),
          color: '#ffffff',
          className: 'text-light bg-info',
          // backgroundColor:"#ffffff"
        };
        setEvents((prev) => [...prev, newEvent]);
      });
    }
  };

  useEffect(() => {
    AddHolidayToEvent();
  }, [holiday]);
  
  
  useEffect(() => {
    if (new Date(new Date(data?.date_start_holiday).setHours(0,0,0,0)) > new Date(new Date(data?.date_end_holiday).setHours(0,0,0,0))) {
      setData((prev) => ({
        ...prev,
        date_start_holiday: data?.date_start_holiday,
        date_end_holiday: data?.date_start_holiday,
      }));
    }
  }, [data?.date_start_holiday]);

  useEffect(() => {
    if (new Date(new Date(data?.date_end_holiday).setHours(0,0,0,0)) < new Date(new Date(data?.date_start_holiday).setHours(0,0,0,0))) {
      setData((prev) => ({
        ...prev,
        date_start_holiday: data?.date_end_holiday,
        date_end_holiday: data?.date_end_holiday,
      }));
    }
  }, [data?.date_end_holiday]);

  const addEventDateFrom = (event) =>{
    if (modalState === "add") {
        setData((prev) => ({
        ...prev,
        date_start_holiday: event,
      }));
    } else {
      setHolidayByID((prev) => ({
        ...prev,
        date_start_holiday: event,
      }));
    }
  }

  const addEventDateTo = (event) =>{
    if (modalState === "add") {
        setData((prev) => ({
          ...prev,
          date_end_holiday: event,
        }));
    } else {
      setHolidayByID((prev) => ({
        ...prev,
        date_end_holiday: event,
      }));
    }
  }

  const handleDatesSet = (info) => {
    const currentYear = info.view.calendar.getDate().getFullYear();
    setCurrentYears(currentYear)
    getHolidays(currentYear);
  };

  const handleDelete = async (id) => {
    const url = `/api/masterdata/holiday/${id}`
    const res = await FetchAxiosDelte(url, token)
    getHolidays(currentYears);
  }

  return (
    <FadeIn>
      <SubMenuLeave menu={5}/>
      <Breadcrumb
        title="หน้าหลัก"
        breadcrumbItem="การลาออนไลน์"
        isBack={true}
        isSubMenu={true}
        subMenuName="ปฏิทินวันหยุด"
        path="/leave"
      />
      <Card style={{ minHeight: "730px" }}>
        <CardBody className="">
          <Row>
            {/* <Col xxl={2}>
              <h4>ปฏิทินวันหยุด</h4>
            </Col> */}
            {/* <Col xxl={2} className="d-flex justify-content-start">
              <Input
                type="select"
                value={selectBudgetYear}
                onChange={(e) => {
                  setSelectBudgetYear(e.target.value);
                  setEvents([]);
                }}
              >
                <option value={budget_year - 0}>{budget_year - 0}</option>
                <option value={budget_year - 1}>{budget_year - 1}</option>
                <option value={budget_year - 2}>{budget_year - 2}</option>
                <option value={budget_year - 3}>{budget_year - 3}</option>
                <option value={budget_year - 4}>{budget_year - 4}</option>
                <option value={budget_year - 5}>{budget_year - 5}</option>
              </Input>
            </Col> */}
            <Col className="d-flex justify-content-end">
              {/* <Button
                className="me-2"
                color="warning"
                onClick={async () => {
                  getHolidays(selectBudgetYear - 543);
                }}
              >
                รีเฟรช
              </Button> */}
              <Button
                color="primary"
                onClick={() => {
                  setModalState((prev) => "add");
                  toggleModalAdd();
                }}
              >
                <i className="fa-solid fa-plus me-1"></i> เพิ่มวันหยุด
              </Button>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Row>
                <Col xxl={12}>
                  <FullCalendar
                    plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                    slotDuration={"00:15:00"}
                    handleWindowResize={true}
                    // year={selectBudgetYear-543}
                    themeSystem="bootstrap"
                    headerToolbar={{
                      // left: "prev,next today",
                      left: "today",
                      center: "title",
                      // right: "year,dayGridMonth,dayGridWeek,dayGridDay",
                      right: "prev,next",
                    }}
                    events={events}
                    locale="th"
                    displayEventTime={false}
                    datesSet={handleDatesSet} 
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={12} xxl={4} className="mt-xl-0 mt-4">
                <Table
                  responsive
                  bordered
                  className="border-2 border-dark text-nowrap"
                  style={{ verticalAlign: "middle"}}
                >
                  <thead>
                    <tr>
                      <th>ชื่อวันหยุด</th>
                      <th>ตั้งแต่วันที่</th>
                      <th>ถึงวันที่</th>
                      <th style={{width: "200px"}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {holiday?.map((item, idx) => {
                      let dateStart = ConvertDate(
                        item?.date_start_holiday
                      ).toThaiDateFullDMY();
                      let dateEnd = ConvertDate(
                        item?.date_end_holiday
                      ).toThaiDateFullDMY();
                      return (
                        <tr key={item?.holiday_main_id}>
                          <td
                            style={{ maxWidth: "200px" }}
                            className="my-0 py-1 text-truncate"
                          >
                            {item?.name_holiday}
                          </td>
                          <td className="my-0 py-1">{dateStart}</td>
                          <td className="my-0 py-1">{dateEnd}</td>
                          <td className="text-center my-0 py-1">
                                <Button
                                  className="px-2 py-1 my-0 me-1"
                                  color="warning"
                                  onClick={async () => {
                                    setModalState((prev) => "edit");
                                    await getHolidayByID(item?.holiday_main_id);
                                    await toggleModalAdd();
                                  }}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Button>
                                <Button
                                  className="px-2 py-1 my-0"
                                  color="danger"
                                  onClick={async () => {
                                    // handleDelete(item?.holiday_main_id)
                                    setModalState((prev) => "delete");
                                    setDeletedID(item?.holiday_main_id)
                                    setConfirmModal(true);
                                  }}
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Modal size="md" centered isOpen={modalAdd} toggle={toggleModalAdd}>
        <ModalHeader toggle={toggleModalAdd}>แบบฟอร์มเพิ่มวันหยุด</ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              setConfirmModal(true);
            }}
          >
            <FormGroup row>
              <Label className="text-end" xxl={3}>
                ชื่อวันหยุด :
              </Label>
              <Col>
                <Input
                  value={
                    modalState === "add"
                      ? data?.name_holiday
                      : holidayByID?.name_holiday
                  }
                  required
                  type="text"
                  placeholder="ใส่ชื่อวันหยุด..."
                  onChange={(e) => {
                    if (modalState === "add") {
                      setData((prev) => ({
                        ...prev,
                        name_holiday: e.target.value,
                      }));
                    } else {
                      setHolidayByID((prev) => ({
                        ...prev,
                        name_holiday: e.target.value,
                      }));
                    }
                  }}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col xxl={6}>
                <Row>
                  <Label xxl={5}>ตั้งแต่วันที่ :</Label>
                  <Col>
                    <NewThaiDatePicker value={modalState === "add" ? data?.date_start_holiday :  holidayByID?.date_start_holiday } setValue={addEventDateFrom} placeholderText="วัน/เดือน/ปี"/>
                  </Col>
                </Row>
              </Col>
              <Col xxl={6}>
                <Row>
                  <Label xxl={4}>ถึงวันที่ :</Label>
                  <Col>
                    <NewThaiDatePicker value={modalState === "add" ? data?.date_end_holiday : holidayByID?.date_end_holiday} setValue={addEventDateTo} placeholderText="วัน/เดือน/ปี"/>
                  </Col>
                </Row>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col className="d-flex justify-content-end">
                <Button
                  className="me-2"
                  color={modalState === "add" ? "success" : "warning"}
                  type="submit"
                >
                  {modalState === "add" ? "เพิ่มวันหยุด" : "แก้ไข"}
                </Button>
                <Button className="" color="danger" onClick={toggleModalAdd}>
                  ปิด
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
      <ConfirmModal
          modal = {confirmModal}
          modalSize = "md"
          modalHeaderContent ={modalState === "delete" ? "คุณต้องการที่จะลบ ใช่หรือไม่?" : modalState === "add" || modalState === "edit" ? "คุณต้องการที่จะบันทึก ใช่หรือไม่?" : ""}
          onClickConfirmBtn={() => {
          if (modalState === "delete") {
            if (deletedID) {
              handleDelete(deletedID);
            }
          } else if (modalState === "add") {
            handleSubmit();
          } else if (modalState === "edit") {
            handleEdit(holidayByID?.holiday_main_id);
          }
          setData((prev) => ({
            ...prev,
            name_holiday: "",
            date_start_holiday: new Date(),
            date_end_holiday: new Date(),
          }));
          setConfirmModal(false)
          }}
          onClickCancelBtn={() => {
          setConfirmModal(false)
          }}
      />
    </FadeIn>
  );
};

export default Menu5;
